import { render, staticRenderFns } from "./FinishedCaseOverview.vue?vue&type=template&id=6cf924b2"
import script from "./FinishedCaseOverview.vue?vue&type=script&lang=js"
export * from "./FinishedCaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports